import { Injectable } from '@angular/core';
import * as moment from 'moment';
import 'moment-timezone';
@Injectable({
  providedIn: 'root'
})

export class UserLocalizationService{
   
  getLocalTimeZone():string{
    return moment.tz.guess();
  }
  getUserTime():string{
    return moment().format('YYYY-MM-DD HH:mm:ss');
  }
  getUserTimeZoneCode():string{
    return moment().tz(this.getLocalTimeZone()).format('z');
  }

  getFormattedDateTimeAsInt(date: Date): number {
    const formattedDate = moment(date).format('MMDDHHmmss');
    return parseInt(formattedDate, 10);
  }
  
  formatToAmPm(value: string): string {
    if (!value) return '';
    const date = new Date(value);
    if (isNaN(date.getTime())) return value;

    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const dd = String(date.getDate()).padStart(2, '0');

    const time = date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
    });

    return `${yyyy}-${mm}-${dd} ${time}`;
  }
}